import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
export class DocumentFieldResource extends BaseCamelCasedResource {
    pk() {
        return this.documentFieldId?.toString() || "";
    }
    static listUrl(allParams = {}) {
        const { applicationId } = allParams;
        if (applicationId !== undefined) {
            return `${this.urlRoot}/application/${applicationId}`;
        }
        throw new Error("DocumentFieldResource require applicationId");
    }
}
DocumentFieldResource.urlRoot = apiResourceUrl("document-fields");
//# sourceMappingURL=DocumentFieldResource.js.map